export function isDocumentValid(viewdocs) {
  return viewdocs.pa || (viewdocs.uuid && viewdocs.idVol);
}
